export default __webpack_public_path__ + "static/media/she-carrer.098ec9c8.png";